import { COMPOSITE_PURCHASE_DOC, DOC_PATH, ENDPOINTS_PATH } from '../config/api';
import Http from '../utils/http';
import ApiEndpoint from '../models/ApiEndpoint';

const http = new Http();

const mapEndpoints = (data: any): ApiEndpoint[] => {
    const result = [];
    for (const endpoint of data.endpoints) {
        result.push(new ApiEndpoint(endpoint.id, endpoint.isAllowed));
    }
    return result;
};

class ApiDocService {
    public getEndpoints(): Promise<ApiEndpoint[]> {
        return http.get(`${DOC_PATH}${ENDPOINTS_PATH}`)
        .then(this.handleEndpointsResponse);
    }

    public setEndpoints(endpoints: string[]): Promise<ApiEndpoint[]> {
        return http.post(`${DOC_PATH}${ENDPOINTS_PATH}`, this.buildSetEndpointsPayload(endpoints))
        .then(this.handleEndpointsResponse);
    }

    public getDoc(): Promise<any> {
        return http.get(`${DOC_PATH}`)
        .then(async (response: Response) => {
            if (response.ok) {
                return await response.json();
              } else {
                throw Error(`${response.status} ${response.statusText}`);
              }
        });
    }

    public getCompositePurchaseDoc(): Promise<any> {
        return http.get(`${DOC_PATH}${COMPOSITE_PURCHASE_DOC}`)
        .then(async (response: Response) => {
            if (response.ok) {
                return await response.json();
              } else {
                throw Error(`${response.status} ${response.statusText}`);
              }
        });
    }

    private handleEndpointsResponse(response: Response) {
        if (response.ok) {
            return response.json()
              .then(data => mapEndpoints(data));
          } else {
            throw Error(`${response.status} ${response.statusText}`);
          }
    }

    private buildSetEndpointsPayload(endpoints: string[]): any {
        const items = endpoints.map((id) => { return {id}; });
        return { endpoints: items };
    }
}

export const apiDocService = new ApiDocService();


// WEBPACK FOOTER //
// ./src/services/ApiDocService.tsx